module.exports = __webpack_public_path__ + "img/icon-calendar.62a9dc5.svg";